import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Abonneren from './pages/Abonneren';
import AppStore from './pages/AppStore';
import Calendar from './pages/Calendar';
import Download from './pages/Download';
import EspnOne from './pages/EspnOne';
import FairPlay from './pages/FairPlay';
import Frontpage from './pages/Frontpage';
import Goal from './pages/Goal';
import GoalVideo from './pages/Goal/Video/GoalVideo';
import { Helmet } from 'react-helmet';
import Ontknoping from './pages/Ontknoping/Ontknoping';
import Partners from './pages/Partners';
import Programmering from './pages/Programmering';

const routes = [
    {
        path: '',
        page: <Frontpage />,
    },
    {
        path: '/download',
        page: <Download />,
    },
    {
        path: '/espn1',
        page: <EspnOne />,
    },
    {
        path: '/abonneren',
        page: <Abonneren />,
    },
    {
        path: '/ontknoping',
        page: <Ontknoping />,
    },
    {
        path: '/eerlijk-spel',
        page: <FairPlay />,
    },
    {
        path: '/programmering',
        page: <Programmering />,
    },
    {
        path: '/partners',
        page: <Partners />,
    },
    {
        path: '/kalender',
        page: <Calendar />,
    },
    {
        path: '/goal',
        page: <Goal />,
    },
    {
        path: '/goal/video',
        page: <GoalVideo />,
    },
    {
        path: '/goal/app-store',
        page: <AppStore />,
    },
];
function App() {
    return (
        <>
            <Helmet>
                <meta property="og:type" content="website" name="og:type" />
                <meta property="og:url" content="%PUBLIC_URL%" name="og:url" />
                <meta
                    property="og:image"
                    name="og:image"
                    content="%PUBLIC_URL%/img/frontpage-top-2.jpg"
                />
                <meta
                    property="og:title"
                    name="og:title"
                    content="ESPN - Kijk alle Eredivisie wedstrijden live!"
                />
                <meta
                    property="og:description"
                    name="og:description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live. Abonneer nu!"
                />
                <meta property="og:locale" content="nl_NL" name="og:locale" />

                <meta
                    property="twitter:title"
                    name="twitter:title"
                    content="ESPN - Kijk alle Eredivisie wedstrijden live!"
                />
                <meta
                    property="twitter:description"
                    name="twitter:description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live. Abonneer nu!"
                />
                <meta
                    property="twitter:image"
                    name="twitter:image"
                    content="%PUBLIC_URL%/img/frontpage-top-2.jpg"
                />
            </Helmet>
            <Router>
                <Routes>
                    {routes.map(route => {
                        return (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={route.page}
                            />
                        );
                    })}
                </Routes>
            </Router>
        </>
    );
}

export default App;
